<div class="px-5 pb-5">
  <h1 class="cbb-page-title mb-4">Productos cemento</h1>
  <app-productos-cemento-tabla></app-productos-cemento-tabla>
</div>
